<template>
    <!--搜尋-->
    <div class="container searchWrapper">
        <div class="row">
            <div class="col-xs-12 col-md-6 col-md-offset-3 searchContent">
                <slot name="title">
                </slot>
                <div class="input-group">
                    <form class="search-container" autocomplete="off" @submit.prevent>
                        <input type="text" id="search-bar"  v-model="keyword" @keypress="onKeypress" placeholder="搜尋更多文章" ref="search">
                        <a href="#" id="search_submit" @click="onClick" >
                            <i class="fas fa-search search-icon"></i>
                        </a>
                    </form>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Search",
        props:{
            types:{
                type: String,
                default: 'All'
            },
            defaultKeyword:{
                type: String,
                default: ''
            }
        },
        data(){
            return {
                keyword:''
            }
        },
        created() {
            this.keyword = this.defaultKeyword

        },
        mounted() {

        },
        methods:{
            onClick(e){
                if (this.keyword !== '') {
                    window.location.href = `${get_host}articles/search/${this.types}/${this.keyword}`

                }
            },
            onKeypress(e){
                if (e.which === 13) {
                   this.onClick(e)
                }
            },
        }
    }
</script>

<style scoped>

</style>